<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="type" placeholder="下发类型">
          <el-option value="" label="下发类型"></el-option>
          <el-option value="1" label="配置"></el-option>
          <el-option value="2" label="命令"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="status" placeholder="状态">
          <el-option value="" label="状态"></el-option>
          <el-option value="0" label="初始化"></el-option>
          <el-option value="1" label="进行中"></el-option>
          <el-option value="3" label="已完成"></el-option>
          <el-option value="4" label="超时"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="devId" label="设备编号"> </el-table-column>
      <el-table-column prop="opType" label="下发类型"> </el-table-column>
      <el-table-column prop="seq" label="序列号"> </el-table-column>
      <el-table-column prop="content" label="内容"> </el-table-column>
      <el-table-column prop="status" label="状态"> </el-table-column>
      <el-table-column prop="cause" label="原因"> </el-table-column>
      <el-table-column prop="ACK" label="网关ACK状态"> </el-table-column>
      <el-table-column prop="ACK" label="节点ACK状态"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column prop="opTime" label="下发时间"> </el-table-column>
      <el-table-column prop="finishTime" label="完成时间"> </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      devId: "",
      type: "",
      status: "",
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      env: this.getEnv(),
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.devId.trim() != "") {
        params.devId = this.devId;
      }
      if (this.type.trim() != "") {
        params.type = this.type;
      }
      if (this.status.trim() != "") {
        params.status = this.status;
      }
      this.$http
        .post(`${this.env}/gatewaymanage/operate/list`, params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.network.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.network.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.network.baitengfa.com";
      }
    },
  },
  components: { Pagination },
};
</script>